/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FolderSymlink = [
  "svg",
  defaultAttributes,
  [
    [
      "path",
      {
        d: "M2 9V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2"
      }
    ],
    ["path", { d: "m8 16 3-3-3-3" }],
    ["path", { d: "M2 16v-1a2 2 0 0 1 2-2h6" }]
  ]
];

export { FolderSymlink as default };
//# sourceMappingURL=folder-symlink.js.map
